<template>
    <div v-loading="loading">
        Filter:
        <!-- <zm-cascader v-model="search"
            :options="filterOption" filterable collapse-tags
            :props="{ checkStrictly: true, multiple: false, value: 'name', label: 'name' }"
            clearable></zm-cascader> -->
        <zm-select v-for="(item, index) in search" :key="index" class="select-inline"
            v-model="search[index]" @change="setOption(index)" clearable filterable>
            <zm-option v-for="option in filterOption[index]" :key="option.name"
            :value="option.name"></zm-option>
        </zm-select>
        <!-- <zm-select v-model="currentSearch" @change="setOption(-1)" clearable>
            <zm-option v-for="option in currentNode.children" :key="option.name"
            :value="option" :label="option.name"></zm-option>
        </zm-select> -->
        <svg></svg>
        <!-- <div id="chart"></div> -->
    </div>
</template>
<script>
/* eslint-disable */
import * as d3 from 'd3'
import { dashboard } from '@/api'
import { getPermission } from '@/api/permission'
export default {
    name: 'dashboard',
    data () {
        return {
            permission: {
                isSuperAdmin: false,
                isSuperOperator: false,
                manageableResources: []
            },
            loading: false,
            search: [''],
            currentSearch: {},
            depth: 0,
            filterOption: [],
            currentNode: {},
            responseData: {},
            data: {}
        }
    },
    mounted () {
        localStorage.path = this.$route.path
        localStorage.params = ''
        this.fetchData()
        this.fetchPermission()
    },
    watch: {
        search () {
            if (this.search.length) {
                let datas = []
                var fullPath = ''
                this.search.map(item => {
                    fullPath += item + '/'
                })
                fullPath = fullPath.length ? fullPath.substr(0, fullPath.length - 1) : ''
                this.setData(this.filterOption, fullPath)
            } else {
                this.data = this.responseData
            }
            this.draw()
        }
    },
    methods: {
        setData (datas, fullPath) {
            for (var i in datas) {
                if (datas[i].fullPath === fullPath) {
                    if (datas[i].children.length) {
                        this.data = datas[i]
                        this.draw()
                    }
                    return
                }
                if (datas[i].children) {
                    this.setData(datas[i].children, fullPath)
                }
            }
        },
        fetchPermission () {
            getPermission('dashboard').then(response => {
                this.permission = response.data
            })
        },
        setOption (index) {
            if (index === -1) {
                this.search[this.search.length] = this.currentSearch.name
                this.filterOption[this.filterOption.length] = JSON.parse(JSON.stringify(this.currentSearch.children))
                this.currentNode = this.currentSearch
                this.currentSearch = {}
                this.data = this.currentNode
                this.draw()
            } else {
                if (this.search[index]) {
                    this.filterOption[index].map(item => {
                        if (item.name === this.search[index]) {
                            this.filterOption[index + 1] = item.children
                            if (item.children.length) {
                                this.search[index + 1] = '' 
                                this.currentNode = item
                                this.data = this.currentNode
                            } else {
                                console.log('push', this.currentNode.fullPath)
                                this.$router.push('/csms/instance?instance=' + this.currentNode.fullPath)
                            }
                        }
                    })
                } else if (this.search[index - 1]) {
                    this.filterOption[index - 1].map(item => {
                        if (item.name === this.search[index - 1]) {
                            if (item.children.length) {
                               this.search[index + 1] = ''
                            }
                            this.currentNode = item
                            this.data = this.currentNode
                        }
                    })
                    this.search.splice(index + 1, this.search.length - index)
                    this.filterOption.splice(index + 1, this.filterOption.length - index)
                } else if (!index) {
                    this.currentNode = this.responseData
                    this.data = this.currentNode
                    this.search = ['']
                    this.filterOption = [this.responseData.children]
                }
                
            }
        },
        fetchData () {
            this.loading = true
            dashboard().then(response => {
                this.loading = false
                this.responseData = response
                this.data = response
                this.filterOption = [response.children]
                // this.filterOption = this.setOption(response.children)
                this.currentNode = response
                this.draw()
            }).catch(() => {
                this.loading = false
            })
        },
        draw () {
            const data = this.data
            var that = this
            var margin = ({top: 20, right: 0, bottom: 30, left: 40})
            var pack = data => d3.pack()
                .size([width, height])
                .padding(10)
            (d3.hierarchy(data)
                .sum(d => d.value)
                .sort((a, b) => b.value - a.value))
            var width = 932
            var height = 932
            var color = d3.scaleLinear()
                .domain([0, 5])
                .range(['rgba(14,113,235,0.1)', 'rgba(14,113,235,0.5)'])
                .interpolate(d3.interpolateHcl)
            const root = pack(data)
            let focus = root
            let view
            const svg = d3.select('svg')
                .attr('viewBox', `-${width / 2} -${height / 2} ${width} ${height}`)
                .style('display', 'block')
                .style('margin', '0 -14px')
                .style('background', 'white')
                .style('cursor', 'pointer')
                .on('click', function (event, d) {
                    if (focus.data.children.length === 1 && !focus.data.children[0].children.length) {
                        console.log('push', focus.data.children[0], that.currentNode.fullPath)
                        that.$router.push('/csms/instance?instance=' + that.currentNode.fullPath)
                    }
                    that.currentNode = data
                    zoom(event, root)
                })
            svg.selectAll('g').remove()
            const node = svg.append('g')
            .selectAll('circle')
            .data(root.descendants().slice(1))
            .join('circle')
                .style('margin', '50px')
                .attr('fill', d => d.children ? color(d.depth) : 'white')
                .attr('stroke', d => d.children ? color(d.depth) : '#0E71EB')
                .attr('pointer-events', d => !d.children ? 'none' : null)
                .on('mouseover', function (event, d) {
                    d3.select(this).attr('stroke', '#0E71EB')
                    d3.select(d.label).style('color', '#0E71EB')
                    d3.select(d.label).style('display', 'inline')
                })
                .on('mouseout', function (event, d) {
                    d3.select(this).attr('stroke', d => d.children ? null : '#0E71EB')
                    d3.select(d.label).style(() => data.children.length < 15 ? "inline" : 'none')
                })
                .on('click', function (event, d) {
                    // console.log(event, d, focus)
                    if (focus !== d) {
                        that.currentNode = d.data
                        zoom(event, d)
                        event.stopPropagation()
                    } else if (focus === d && (!d.children.length || !d.children[0].data.children.length)) {
                        console.log(d.data.name)
                        console.log('push', d.data.fullPath)
                        that.$router.push('/csms/instance?instance=' + d.data.fullPath)
                    } else if (focus === d && !(!d.children.length || !d.children[0].data.children.length)) {
                        zoom(event, root)
                    }
                })
            // d3.selectAll("circle")
            //     .delay(function(d, i) { return i * 10; })
            const label = svg.append('g')
                .style('color', '#0E71EB')
                .style('font', '24px sans-serif')
                .attr('pointer-events', 'none')
                .attr('text-anchor', 'middle')
            .selectAll('text')
            .data(root.descendants())
            .join('text')
                .style('color', '#0E71EB')
                .style('fill-opacity', d => d.parent === root ? 1 : 0)
                .style('display', () => data.children.length < 15 ? "inline" : 'none')
                .text(function(d) {
                    d.label = this
                    return d.data.name
                })
            zoomTo([root.x, root.y, root.r * 2])

            function zoomTo (v) {
                const k = width / v[2]
                view = v
                label.attr('transform', d => `translate(${(d.x - v[0]) * k},${(d.y - v[1]) * k})`)
                node.attr('transform', d => `translate(${(d.x - v[0]) * k},${(d.y - v[1]) * k})`)
                node.attr('r', d => d.r * k)
            }
            function zoom (event, d) {
                // const focus0 = focus
                focus = d
                const transition = svg.transition()
                    .duration(event.altKey ? 7500 : 750)
                    .tween('zoom', d => {
                    const i = d3.interpolateZoom(view, [focus.x, focus.y, focus.r * 2.3])
                    return t => zoomTo(i(t))
                    })
                label
                .filter(function (d) { return d.parent === focus || this.style.display === 'inline' })
                .transition(transition)
                    .style('fill-opacity', d => d.parent === focus ? 1 : 0)
                    .on('start', function (d) {
                        if (d.parent === focus) this.style.display = data.children.length < 15 ? "inline" : 'none'
                        if (!d.children) this.style.display = 'inline'
                    })
                    .on('end', function (d) {
                        if (d.parent !== focus) this.style.display = 'inline'
                        if (!d.children) this.style.display = 'inline'
                    })
            }
            return svg.node()
        }
    }
}
</script>
<style scoped>
#chart {
    height: calc(100vh - 120px)
}
svg {
    width: 100%;
    height: calc(100vh - 120px);
    /* border: 1px solid #ccc; */
}
</style>
<style>
text {
    color: rgb(14, 113, 235);
}
.links line {
  stroke: #999;
  stroke-opacity: 0.6;
}
.nodes circle {
  stroke: #fff;
  stroke-width: 1.5px;
}
</style>

